enum DiscountType {
  CASH = "cash",
  PERCENT = "percent",
}

export { DiscountType };
